import type { IStatsRepository } from "@src/domain/stats/repository/stats_repository";
import type { StatsDTO } from "../dto";
import { GetStatsUseCase } from "./get_stats.usecase";

/**
 * Stats Service
 * Consolidated service that provides access to all stats-related use cases
 * This class serves as a facade pattern to simplify usage of use cases
 * 
 * IMPORTANT: This service only exposes DTOs to the presentation layer,
 * ensuring proper separation between domain and presentation concerns.
 */
export class StatsService {
    // Use case instances
    private readonly getStatsUseCase: GetStatsUseCase;

    constructor(statsRepository: IStatsRepository) {
        // Initialize all use cases with the repository
        this.getStatsUseCase = new GetStatsUseCase(statsRepository);
    }

    /**
     * Get current application statistics
     * @returns Promise<StatsDTO> - Current statistics data
     */
    async getStats(): Promise<StatsDTO> {
        return await this.getStatsUseCase.execute();
    }
}
